module.exports = __webpack_public_path__ + "static/media/ios-bug.38751a5f.svg";